var _termsDefaut = {
  protocolPlural: 'Protocolos',
  protocolSaved: 'Protocolo salvo com sucesso.',
  protocolSingular: 'Protocolo'
};

MdHub.dict = {
  _terms: _termsDefaut,

  /**
   * Função que será utlizada dentro de cada modulo
   */
  get: function get(term, termNotFound) {
    if (Object.prototype.hasOwnProperty.call(this._terms, term)) {
      return JSON.parse(JSON.stringify(this._terms[term]));
    }

    return termNotFound;
  },

  getAll: function getAll() {
    // clona o objeto de forma a perder a referencia
    return JSON.parse(JSON.stringify(this._terms));
  },

  set: function set(terms) {
    var term;

    for (term in terms) {
      if (Object.prototype.hasOwnProperty.call(this._terms, term)) {
        this._terms[term] = terms[term];
      }
    }

    MdHub.event.trigger('core:setDictionary', this.getAll());
    return this.getAll();
  }
};
